/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/rewards/reward_activity';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "SearchRewardsActivityRequest": {
                "fields": {
                  "creditLineId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "limit": {
                    "type": "int32",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "SearchRewardsActivityResponse": {
                "fields": {
                  "rewardActivities": {
                    "type": ".squareup.corporate_card.resources.rewards.RewardActivity",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.SearchRewardsActivityRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.SearchRewardsActivityResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE SearchRewardsActivityRequest @ squareup/corporate_card/service/search_rewards_activity.proto at 9:1
 */
export const SearchRewardsActivityRequest = $root.lookupType('squareup.corporate_card.service.SearchRewardsActivityRequest');
fixType(SearchRewardsActivityRequest);
Builder.createAndAttachToType(SearchRewardsActivityRequest);
/**
 * SOURCE SearchRewardsActivityResponse @ squareup/corporate_card/service/search_rewards_activity.proto at 29:1
 */
export const SearchRewardsActivityResponse = $root.lookupType('squareup.corporate_card.service.SearchRewardsActivityResponse');
fixType(SearchRewardsActivityResponse);
Builder.createAndAttachToType(SearchRewardsActivityResponse);